import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './real_time_text.css';

const RealTimeText = ({ text }) => {
  const textContainerRef = useRef(null);

  useEffect(() => {
    if (textContainerRef.current) {
      textContainerRef.current.scrollTop = textContainerRef.current.scrollHeight;
    }
  }, [text]);

  return (
    <div className="textContainer" ref={textContainerRef}>
      {text}
    </div>
  );
};

export default RealTimeText;